import { useNavigate } from "react-router-dom";
import Button from "../User/Common/Button";

const CTABanner = () => {
  const navigate = useNavigate();

  return (
    <div
      className="w-full bg-white px-4 sm:px-6 md:px-10 pb-6 overflow-hidden"
      data-aos="fade-up"
    >
      <div
        className="max-w-full mx-auto 
        rounded-tr-[2rem] rounded-bl-[2rem] rounded-tl-lg rounded-br-lg 
        px-5 sm:px-8 md:px-10 py-8 sm:py-10 text-center relative overflow-hidden"
      >
        {/* Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#041122] via-[#2a0535] to-[#B3129E]" />

        {/* Subtle pattern */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "radial-gradient(circle, white 1px, transparent 1px)",
            backgroundSize: "28px 28px",
          }}
        />

        {/* Existing dark overlay */}
        <div className="absolute inset-0 bg-black/20 pointer-events-none" />

        <h2
          className="text-white font-bold mb-6 sm:mb-7 relative z-10 leading-normal 
          font-heading tracking-wide text-2xl sm:text-3xl md:text-4xl"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          At Mix Masters, we're transforming concrete production
          <br className="hidden sm:block" />
          with cutting-edge technology.
        </h2>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
          mx-auto max-w-full xl:max-w-[75%] items-center justify-center 
          gap-3 sm:gap-4 mb-8 relative z-10"
        >
          {["AI-Based Batching Systems", "IoT Integration", "Automation"].map(
            (label, index) => (
              <div
                key={label}
                className="px-5 sm:px-7 py-3 sm:py-4 rounded-md bg-white 
                text-primaryAccent font-bold text-sm sm:text-base"
                data-aos="zoom-in"
                data-aos-delay={200 + index * 100}
              >
                {label}
              </div>
            ),
          )}
        </div>

        <div
          className="relative z-10 w-full flex items-center justify-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <Button onClick={() => navigate("/contact")} text={"Contact Us"} />
        </div>
      </div>
    </div>
  );
};

export default CTABanner;